import axios from "axios";
import { apiurl } from "configs/config";
import ApiClient from "./ApiClient";
import toast from "react-hot-toast";


class ReportService {
 constructor(callback) {
        this.callback = callback
    }

   
    async StockReport(payload) {
        const response = await axios.get(
            `${apiurl}/api/Transaction/GetAllStock?TempleId=${payload.TempleId}&ToDate=${payload.ToDate}`,
       
        ).then((response) => {
            return response.data;
            
        }).catch((error) => ({ error: JSON.stringify(error) }));
        return response;
    }

    async ItemLedger(payload) {
        const response = await axios.get(
            `${apiurl}/api/Report/GetLegerReport?TempleId=${payload.TempleId}&FromDate=${payload.FromDate}&ToDate=${payload.ToDate}&ItemId=${payload.ItemId}`,
       
        ).then((response) => {
            return response.data;
            
        }).catch((error) =>
        {
            toast.error("No data found for this date");
            return { error: JSON.stringify(error) };
        }); 
        return response;
    }
   
   
   
    async RecipesReport(payload) {
        const response = await axios.get(
            `${apiurl}/api/Report/spGetrecipesReport?TempleId=${payload.TempleId}&Date=${payload.Date}&Session=${payload.Session}`,
       
        ).then((response) => {
            
            const empty=response?.data?.result
            if(empty?.length==0){
                toast.error("No data available for the particular date");
                return response.data;
            }
            return response.data;
            
        }).catch(error => {
            toast.error("No data found for this date");
            return { error: JSON.stringify(error) };
        });
        
        return response;
    }
   
   
    async sectionmapper(payload) {
        console.log("payload",payload);
        const response = await axios.get(
            `${apiurl}/api/Session/GetSessionMapperData?TempleId=${payload.TempleId}`,
       
        ).then((response) => {
            return response.data;
            
        }).catch((error) => ({ error: JSON.stringify(error) }));
        return response;
    }
   
   
    async TransactionReport(payload) {
        const response = await axios.get(
            `${apiurl}/api/Transaction/GetTransactionDetailsWithType?TempleId=${payload.TempleId}&Type=${payload.Type}&From=${payload.From}&To=${payload.To}`,
       
        ).then((response) => {
            const empty=response?.data?.Result
            if(empty?.length==0){
                toast.error("No data available for the particular date");
                return response.data;
            }
            return response.data;
            
        }).catch((error) => {
            toast.error("No data available for the particular date");
            { error: JSON.stringify(error) }
        }   )         ;
        return response;
    }
   
    async approvalList(payload) {
        const response = await axios.get(
            `${apiurl}/api/Transaction/GetTransactionWithTypeAndIsApprove?TempleId=${payload.TempleId}&Type=${payload.Type}&From=${payload.From}&To=${payload.To}`,
       
        ).then((response) => {
            return response.data;
            
        }).catch((error) => ({ error: JSON.stringify(error) }));
        return response;
    }
   
    async approval(payload) {
        
        const response = await axios.post(
            `${apiurl}/api/Master/SetAprove`,payload,
       
        ).then((response) => {
            return response.data;
            
        }).catch((error) => ({ error: JSON.stringify(error) }));
        return response;
    }
   
   
   
   
    
}
export default new ReportService();